import { FluidContainer } from '@atlassian/mpac-primitives';
import { useHostUrl, useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { FeaturedSection } from '../components/FeaturedSection';
import { Hero } from '../components/Hero';
import { TrustSignalsSection } from '../components/TrustSignalsSection';
import { getAppListingUrl } from '../utils';
const Homepage = () => {
  const hostUrl = useHostUrl();
  const source = useSource();
  const onTileClick = appKey => {
    const appListingUrl = getAppListingUrl(source, hostUrl, appKey);
    window.open(appListingUrl);
  };
  console.log(hostUrl, source, onTileClick);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hero, null), /*#__PURE__*/React.createElement(FluidContainer, null, /*#__PURE__*/React.createElement(FeaturedSection, null), /*#__PURE__*/React.createElement(TrustSignalsSection, null)));
};
export default Homepage;